<template>
	<el-drawer size="60%" :title="title" :visible.sync="dialogVisible" direction="rtl" :wrapperClosable="false"
		class="customer-drawer-common website-detail">
		<section class="preview-box">
			<PreviewBox :data="form"></PreviewBox>
		</section>
		<section class="form-box">
			<el-form ref="form" :model="form" :rules="formRules" label-width="120px">
				<el-form-item label="网站名称" prop="name">
					<el-input v-model="form.name" placeholder="请输入网站名称：" size="small"></el-input>
				</el-form-item>
				<el-form-item label="是否启用机器人" prop="machine">
					<el-switch v-model="form.machine" active-text="是" inactive-text="否" size="small"></el-switch>
				</el-form-item>
				<el-form-item label="默认欢迎语" prop="default_welocme">
					<el-input v-model="form.default_welocme" placeholder="请输入默认欢迎语：" size="small"></el-input>
				</el-form-item>

				<el-form-item label="网站描述" prop="desc">
					<el-input type="textarea" resize="none" :rows="5" v-model="form.desc" placeholder="请输入备注">
					</el-input>
				</el-form-item>
				<el-row>
					<el-col :span="12">
						<el-form-item label="网站主题颜色" prop="theme_color">
							<el-color-picker v-model="form.theme_color" size="mini"></el-color-picker>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="网站主题对应文字颜色" prop="theme_font_color" label-width="150px">
							<el-color-picker v-model="form.theme_font_color" size="mini"></el-color-picker>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item label="网站文字颜色" prop="text_color">
							<el-color-picker v-model="form.text_color" size="mini"></el-color-picker>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="网站文字灰度颜色" prop="text_inverse_color">
							<el-color-picker v-model="form.text_inverse_color" size="mini"></el-color-picker>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="6">
						<el-form-item label="网站logo" prop="logo">
							<el-upload class="upload-logo" action="" :http-request="uploadEvent" :show-file-list="false"
								accept=".jpg,.png,.jpeg,.bmp">
								<img v-if="form.logo" :src="form.logo" class="avatar">
								<i v-else class="el-icon-plus upload-logo-icon"></i>
							</el-upload>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="坐席头像" prop="agent_avator">
							<el-upload class="upload-logo" action="" :http-request="uploadEvent" :show-file-list="false"
								accept=".jpg,.png,.jpeg,.bmp">
								<img v-if="form.agent_avator" :src="form.agent_avator" class="avatar">
								<i v-else class="el-icon-plus upload-logo-icon"></i>
							</el-upload>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="非工作时间二维码" prop="code_image">
							<el-upload class="upload-logo" action="" :http-request="uploadEvent" :show-file-list="false"
								accept=".jpg,.png,.jpeg,.bmp">
								<img v-if="form.code_image" :src="form.code_image" class="avatar">
								<i v-else class="el-icon-plus upload-logo-icon"></i>
							</el-upload>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="8">
						<el-form-item label="是否有隐私政策" prop="is_has_private_policy">
							<el-switch v-model="form.is_has_private_policy" active-text="是" inactive-text="否" size="small">
							</el-switch>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="隐私政策类型" v-if="form.is_has_private_policy">
							<el-radio-group v-model="form.private_policy_type">
								<el-radio :label="1">链接</el-radio>
								<el-radio :label="2">文本</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
				</el-row>
				<el-form-item v-if="form.is_has_private_policy"
					:label="form.private_policy_type == 1 ? '隐私政策链接':'隐私政策内容'" prop="private_policy_content">
					<el-input :type="form.private_policy_type == 2 ? 'textarea' : 'text'" resize="none" :rows="5"
						v-model="form.private_policy_content" placeholder="请输入..."></el-input>
				</el-form-item>
				<el-row>
					<el-col :span="8">
						<el-form-item label="是否有服务条款" prop="is_has_service_policy">
							<el-switch v-model="form.is_has_service_policy" active-text="是" inactive-text="否" size="small">
							</el-switch>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="服务条款类型" v-if="form.is_has_service_policy">
							<el-radio-group v-model="form.service_policy_type">
								<el-radio :label="1">链接</el-radio>
								<el-radio :label="2">文本</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
				</el-row>
				<el-form-item v-if="form.is_has_service_policy"
					:label="form.service_policy_type == 1 ? '服务条款链接':'服务条款内容'" prop="service_policy_content">
					<el-input :type="form.service_policy_type == 2 ? 'textarea' : 'text'" resize="none" :rows="5"
						v-model="form.service_policy_content" placeholder="请输入..."></el-input>
				</el-form-item>
			</el-form>
			<div class="footer">
				<el-button @click="dialogVisible = false" size="mini">取 消</el-button>
				<el-button type="primary" size="mini" @click="onSave" :loading="loading">
					{{ loading ? '提交中 ...' : '确 定' }}
				</el-button>

			</div>
		</section>
	</el-drawer>
</template>

<script>
	import PreviewBox from './preview.vue'
	export default {
		components: {
			PreviewBox
		},
		props: ['title'],
		data() {
			return {
				dialogVisible: false,
				loading: false,
				form: {
					name: '',
					logo: '',
					agent_avator: '',
					code_image: '',
					machine: false,
					theme_color: '#337eff',
					theme_font_color: '#fff',
					text_color: '#3c4353',
					text_inverse_color: '#838a9d',
					is_has_private_policy: false,
					private_policy_content: '',
					private_policy_type: 1,
					is_has_service_policy: false,
					service_policy_content: '',
					service_policy_type: 1,
					desc: '',
					default_welocme: ''
				},
				formRules: {
					name: [{
						required: true,
						message: '请输入网站名称',
						trigger: 'blur'
					}],
					theme_color: [{
						required: true,
						message: '请选择颜色',
						trigger: 'change'
					}],
					theme_font_color: [{
						required: true,
						message: '请选择颜色',
						trigger: 'change'
					}],
					text_color: [{
						required: true,
						message: '请选择颜色',
						trigger: 'change'
					}],
					text_inverse_color: [{
						required: true,
						message: '请选择颜色',
						trigger: 'change'
					}],
					logo: [{
						required: true,
						message: '请上传网站logo',
						trigger: 'change'
					}],
					agent_avator: [{
						required: true,
						message: '请上传坐席头像',
						trigger: 'change'
					}],
					private_policy_content: [{
						required: true,
						message: '请输入内容',
						trigger: 'blur'
					}],
					service_policy_content: [{
						required: true,
						message: '请输入内容',
						trigger: 'blur'
					}]
				}
			}
		},
		methods: {
			uploadEvent() {

			},
			onSave() {
				this.$refs.form.validate((valid) => {
					if (valid) {

					}
				})
			},
			openDetail(){
				this.dialogVisible = true
			}
		},
	}
</script>

<style lang="scss" scoped>
	.website-detail {
		
		::v-deep .el-drawer__body {
			display: flex;
			justify-content: space-between;
		}
		.form-box {
			width: calc(100% - 320px);
			padding-bottom: 50px;
			
		}
		.preview-box {
			width: 320px;
		}

		.upload-logo .el-upload {
			border: 1px dashed #d9d9d9;
			border-radius: 6px;
			cursor: pointer;
			position: relative;
			overflow: hidden;
		}

		.upload-logo .el-upload:hover {
			border-color: #409EFF;
		}

		.upload-logo-icon {
			font-size: 28px;
			color: #8c939d;
			width: 88px;
			height: 88px;
			line-height: 88px;
			text-align: center;
			border: 1px dashed #d9d9d9;
		}

		.avatar {
			width: 88px;
			height: 88px;
			display: block;
		}
	}
</style>
